// Preserve selections through the legacy CurriculumChallenge interface in cache.
export const curriculumPossibleTypes = {
  CurriculumChallenge: [
    'DefinitionsChallenge',
    'GalleryChallenge',
    'GroupingChallenge',
    'Grouping2Challenge',
    'JumbledSentenceChallenge',
    'JumbledWordChallenge',
    'LongWritingChallenge',
    'MatchingChallenge',
    'MissingWordChallenge',
    'MissingWordTypingChallenge',
    'NamingsChallenge',
    'ParagraphsChallenge',
    'QuizChallenge',
    'ReadingComprehensionChallenge',
    'ShortWritingChallenge',
    'WordRapChallenge',
    'WordSearchChallenge',
  ],
}
